<template>
  <div>
    med cert preview
  </div>
</template>